import { request } from "@/utils/request";
/**
 * 查询系统任务
 * @param {*} data 
 * @returns 
 */
export function selectApi(data) {
  return request({
    url: `/admin/sysTask/select`,
    method: "POST",
    data,
  });
}

/**
 * 新增系统任务
 * @param {*} data 
 * @returns 
 */
export function addApi(data) {
  return request({
    url: `/admin/sysTask/add`,
    method: "POST",
    data,
  });
}

/**
 * 修改系统任务
 * @param {*} data 
 * @returns 
 */
export function updateApi(data) {
  return request({
    url: `/admin/sysTask/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除系统任务
 * @param {*} data 
 * @returns 
 */
export function deleteApi(data) {
  return request({
    url: `/admin/sysTask/delete`,
    method: "POST",
    data,
  });
}
